// extracted by mini-css-extract-plugin
export default {"ChartContainer":"drawdownChart_ChartContainer__78ac-","Chart":"drawdownChart_Chart__fMNZA"};